import { instance } from '@/services/avik-api-gateway'
import { DeviationDisruption } from '@/types/deviation-disruption'
import { AxiosResponse } from 'axios'

export function deleteDeviationDisruption(
  deviationDisruptionUuid: string
): Promise<AxiosResponse<DeviationDisruption>> {
  return instance.delete(`/deviation-disruption/${deviationDisruptionUuid}`)
}
